<template>
    <div>
        <!-- 导航 -->
        <share-nav :navigationLineLeft="'535px'"/>

        <!-- 轮播图 -->
        <a-carousel arrows autoplay :dots="false">
            <template #prevArrow>
                <div class="custom-slick-arrow arrow-btn-left">
                    <i class="iconfont icon-zuojiantou"></i>
                </div>
            </template>
            <template #nextArrow>
                <div class="custom-slick-arrow arrow-btn-right">
                    <i class="iconfont icon-youjiantou"></i>
                </div>
            </template>
            <div class="lbt-img" v-for="_ in nanLbtList" :key="_.id">
                <u-image style="width:100%;height: 450px" :src="_.picUrl" />
            </div>
        </a-carousel>
        
        <!-- 上部分 -->
        <div class="top phone-class">
            <div class="top-container phone-class">
                <!-- 左边 -->
                <div class="top-left phone-content">
                    <div v-for="(_,idx) in newList" :key="_.id">
                        <!-- 新闻1 -->
                        <div v-if="!idx" class="phone-class">
                            <!-- 大新闻 -->
                            <router-link class="dxw" :to="'/details?id=' + _.id">
                                <div id="xw1-large" class="large">
                                    <div class="heavy-time">
                                        <p>{{_?.publishTime.slice(8,10)}}</p>
                                        <p>{{_?.publishTime.slice(0,7)}}</p>
                                    </div>
                                    <a href="{$val[url]}" class="heavy-news" style="width: calc(100% - 110px)">
                                        <p class="text-overflow">{{_?.title}}</p>
                                        <span class="span-text">{{_.contentAbstract}}</span>
                                    </a>
                                </div>
                            </router-link>
                        </div>
                        <!-- 新闻2 -->
                        <div v-else class="phone-class xw" @mouseenter="xwMouseenter(idx)" @mouseleave="xwMouseleave(idx)">
                            <!-- 小新闻 -->
                            <router-link :to="'/details?id=' + _.id">
                                <div id="xw2-small" class="small">
                                    <div class="li-time">
                                        <p>{{_?.publishTime.slice(8,10)}}</p>
                                        <p>{{_?.publishTime.slice(0,7)}}</p>
                                    </div>
                                    <span class="vertical-line"></span>
                                    <a href="{$val[url]}">
                                        <div class="li-text">
                                            <span class="color-red text-overflow">{{_?.title}}</span>
                                        </div>
                                        <div class="div-i">
                                            <i id="xiangyou1" class="iconfont icon-youjiantou xiangyou1 xiangyou"></i>
                                            <i id="xiangyou2" class="iconfont icon-xiangyou xiangyou2 xiangyou"></i>
                                        </div>
                                    </a>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- 中间 -->
                <div class="top-middle phone-content">
                    <router-link :to="'/tzzgx?subNavNumber=1'">
                        <div class="notice-block-warper newest-notice">
                            <div class="notice-block">
                                <div class="notice">
                                    <p class="fs-24">最新公告</p>
                                    <p class="fs-14">NOTICE</p>
                                </div>
                                <p class="notice-p1 text-overflow-two">{{zxggList[0]?.title}}</p>
                                <p class="notice-p2">{{zxggList[0]?.publishTime.slice(0,10)}}</p>
                            </div>
                        </div>
                    </router-link>
                    <router-link :to="'/tzzgx?subNavNumber=2'">
                        <div class="notice-block-warper public-welfare">
                            <div class="notice-block">
                                <div class="notice">
                                    <p class="fs-24">社会责任</p>
                                    <p class="fs-14">SOCIAL RESPONSIBILITY</p>
                                </div>
                                <p class="notice-p1 text-overflow-two">{{shzrList[0]?.title}}</p>
                                <p class="notice-p2">{{shzrList[0]?.publishTime.slice(0,10)}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <!-- 中间产业布局 -->
        <div class="industry-container">
            <div class="industry-external phone-class">
                <div class="industry-inside phone-class">
                    <div v-for="(_,idx) in cybjListSlice" :key="_.id">
                        <!-- 模块卡片 -->
                        <div class="industry-card phone-content"  :class="idx<6 ? '' : (!this.isCybj ? 'no-display' : '')" :style="!((idx+1) % 3) ? 'margin-right:0;' : ''">
                            <u-image :src="_.picUrl" />
                            <div class="industry-introduce">
                                <p class="introduce-title text-overflow">{{_?.title}}</p>
                                <p class="introduce-line"></p>
                                <div class="introduce-content">
                                    <div v-html="_.contentAbstract"></div>
                                </div>
                                <router-link class="introduce-button" to="/cybj">查看详情</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="industry-more phone-content">
                        <a class="more-button" href="JavaScript:;" @click="()=>this.isCybj = !this.isCybj">{{!isCybj ? '显示更多' : '点击收起'}}</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 下部分 -->
        <div class="bottom phone-class">
            <div class="bottom-container phone-class">
                <!-- 左侧 -->
                <share-quotation />
                <!-- 右侧 -->
                <div class="bottom-right phone-content">
                    <div class="video">
                        <video :src="videoData.picUrl" controls poster="../assets/cover.png" style="object-fit: cover"></video>
                    </div>
                    <div class="compliance">
                        <u-image class="img-logo" src="../assets/logo.png" alt="/" />
                        <p>敬人 &nbsp; 敬业 &nbsp; 致实 &nbsp; 致远</p>
                        <p>点击观看浙江东日股份有限公司形象片</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 页尾 -->
        <share-footer />

        <!-- 网站地图 -->
        <share-map />
    </div>
</template>

<script>
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';
import { getLbtList, getXwList, getSimpleList, getVideo, } from "@/api/index.js";
import shareNav from "./share-nav.vue";
import shareQuotation from "./share-quotation.vue";
import shareFooter from "./share-footer.vue";
import shareMap from "./share-map.vue";
export default {
    components: { shareNav, shareQuotation, shareFooter, shareMap, LeftCircleOutlined, RightCircleOutlined},
    data() {
        return {
            nanLbtList: [],
            newList: [],
            zxggList: [],
            shzrList: [],
            cybjList: [],
            videoData: {},
            isCybj: false,
        };
    },
    computed: {
        // 轮播图的样式
        cybjListSlice() {
            return this.isCybj ? this.cybjList : this.cybjList.slice( 0, 6);
        },
    },
    created() {
        // 获取轮播图
        getLbtList({current: -1, size: 999, type: 'BANNER'}).then((res)=>{
            this.nanLbtList = res.data.records || []
        })
        // 获取公司新闻
        getXwList({contentType: 'COMMON_NEWS', current: 1, size: 5}).then((res)=>{
            this.newList = res.data.records || []
        })
        // 最新公告
        getXwList({contentType: 'COMMON_ANNOUNCE', current: 1, size: 1}).then((res)=>{
            this.zxggList = res.data.records || []
        })
        // 社会责任
        getXwList({contentType: 'COMMON_RESPONSE', current: 1, size: 1}).then((res)=>{
            this.shzrList = res.data.records || []
        })
        // 产业布局
        getSimpleList({contentType: 'GRID_INDUSTRY'}).then((res)=>{
            this.cybjList = res.data || []
        })
        // 宣传视频
        getVideo({type: 'VIDEO'}).then((res)=>{
            this.videoData = res.data || {}
        })
    },
    methods: {
        // 新闻
        xwMouseenter(idx){
            let XiangYou = document.getElementsByClassName('xiangyou');
            let ColorRed = document.getElementsByClassName('color-red');
            let VerticalLine = document.getElementsByClassName('vertical-line');
            VerticalLine[idx-1].style.transition = 'height 0.3s';
            VerticalLine[idx-1].style.height = '0';
            ColorRed[idx-1].style.color = 'red';
            XiangYou[(idx-1)*2].style.transition = 'margin-left 0.3s'
            XiangYou[(idx-1)*2].style.marginLeft = '20px';
            XiangYou[idx*2-1].style.transition = 'margin-left 0.3s'
            XiangYou[idx*2-1].style.marginLeft = '90px';
        },
        xwMouseleave(idx){
            let XiangYou = document.getElementsByClassName('xiangyou');
            let ColorRed = document.getElementsByClassName('color-red');
            let VerticalLine = document.getElementsByClassName('vertical-line');
            VerticalLine[idx-1].style.transition = 'height 0.3s';
            VerticalLine[idx-1].style.height = '50px';
            ColorRed[idx-1].style.color = '#898989';
            XiangYou[(idx-1)*2].style.transition = 'margin-left 0.3s'
            XiangYou[(idx-1)*2].style.marginLeft = '-50px';
            XiangYou[idx*2-1].style.transition = 'margin-left 0.3s'
            XiangYou[idx*2-1].style.marginLeft = '57px';
        },
    },
};
</script>
<style lang="less" scoped>
@import url(../style/index/index.css);
.ant-carousel .slick-slide {
    text-align: center;
    height: 324px;
    overflow: hidden;
}
.ant-carousel .custom-slick-arrow {
  width: 57px;
  height: 57px;
  font-size: 30px;
  line-height: 57px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  background-color: rgba(0, 0, 0, 0);
}
.ant-carousel .custom-slick-arrow:before {
  display: none;
}
.ant-carousel .custom-slick-arrow:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.arrow-btn-left{
    width: 0 !important;
    border: 0 !important;
    left: 0px; 
    z-index: 1;
    i{
        display: none !important;
        font-size: 30px;
    }
}
.arrow-btn-right{
    width: 0 !important;
    border: 0 !important;
    right: 0px;
    i{
        display: none !important;
        font-size: 30px;
    }
}
.lbt-img{
    z-index: 9;
    cursor: pointer;
}
.slick-slider:hover{
    .arrow-btn-left {
        transition: width 0.4s;
        width: 57px !important;
        transition: left 0.4s;
        left: 40px !important;
        border: 1px solid #fff !important;
        i{
            display: block !important;
        }
    }
    .arrow-btn-right {
        transition: width 0.4s;
        width: 57px !important;
        transition: right 0.4s;
        right: 40px !important;
        border: 1px solid #fff !important;
        i{
            display: block !important;
        }
    }
}
// 文字省略号
.text-overflow-two{
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical; /* 必须结合的属性，用来设置或检索伸缩盒对象的子元素的排列方式 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
}
</style>